const normalizeValue = (value) => (value || '').toString().trim().toLowerCase();

/** Known third-party resellers — excluded from default “manufacturer retailers” selection on Brand Board. */
export const THIRD_PARTY_RETAILERS = new Set(['eliquidshop', 'vapoo']);

/**
 * Retailers to select by default: all channels except {@link THIRD_PARTY_RETAILERS}.
 */
export const getDefaultManufacturerRetailers = (retailerNames) => {
  if (!Array.isArray(retailerNames) || retailerNames.length === 0) return [];
  return retailerNames.filter((name) => !THIRD_PARTY_RETAILERS.has(normalizeValue(name)));
};

const PROJECT_TO_COUNTRY_MATCH = {
  cz: ['cz', 'czech', 'czech republic', 'ceska', 'cesko'],
  ro: ['ro', 'romania', 'rou'],
  it: ['it', 'italy', 'ita', 'italia'],
  uk: ['uk', 'united kingdom', 'gb', 'gbr'],
  pl: ['pl', 'poland', 'pol', 'polska'],
  de: ['de', 'germany', 'deu', 'deutschland']
};

/**
 * Get the default country code for a project when viewing brand board.
 * E.g. projectKey 'cz' or 'jti-cz' -> matches 'cz' in data.
 */
export const getDefaultCountryForProject = (projectKey, availableCountries) => {
  if (!projectKey || !Array.isArray(availableCountries) || availableCountries.length === 0) {
    return null;
  }
  const key = (projectKey || '').toString().toLowerCase();
  const matchList = PROJECT_TO_COUNTRY_MATCH[key] ||
    Object.entries(PROJECT_TO_COUNTRY_MATCH).find(([code]) => key.includes(code))?.[1];
  if (!matchList) return null;
  return availableCountries.find((c) =>
    matchList.some((m) => normalizeValue(c) === m || normalizeValue(c).includes(m))
  ) || null;
};
